import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintWawancara = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocWawancara = ({ innerRef, item, type }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td colSpan={5} style={{ textAlign: "center", fontWeight: "bold", fontSize: "18px", padding: "8px", border: "1px solid #000" }}>
                FORM WAWANCARA
              </td>
            </tr>
            <tr>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px" }}>Cabang</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>{item.sales_branch && item.sales_branch.name}</td>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px" }}>Nama Pemohon</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                {item.sls_appl?.name ?? "-"}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>No. Kontrol</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>LMS No. :</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Nama Petugas</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>{item.sales_agent && item.sales_agent.name}</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Produk</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}>NIP</td>
              <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}>Subsidi / Non Subsidi</td>
              <td colSpan={2} style={{ border: "1px solid #000", borderBottom: "0px", padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>
        {/* Bagian A */}
        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td colSpan={5} style={{ backgroundColor: "#d9d9d9", fontWeight: "bold", textAlign: "center", padding: "6px", height: "32px", border: "1px solid #000" }}>
                {/* A. VALIDITAS DAN KELENGKAPAN DATA DEBITUR */}
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                A. VALIDITAS DAN KELENGKAPAN DATA DEBITUR
              </td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                Cek Kesesuaian Fisik
              </td>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                A.1 Kelengkapan Data Debitur
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Sesuai</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                1. Identitas Diri (KTP / Paspor)
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Photo Pribadi (KTP / Pas Foto vs Aktual)
                <br />
                Bentuk Tandatangan (di Form Aplikasi vs KTP)
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>

            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                A.2 Validitas Data Debitur
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Valid</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Validitas KTP / Identitas Lainnya
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Masa Berlaku KTP / Paspor
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td rowSpan={2} colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                B. PENJELASAN MENGENAI PRODUK
              </td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}></td>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Ya</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Calon Debitur Sudah Faham akan Produk yang akan Dibeli
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td colSpan={5} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                C. PENJELASAN MENGENAI HUBUNGAN ANTARA BANK - DEVELOPER – DEBITUR
              </td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.1</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                <span style={{ fontWeight: "bold" }}>Bank - Debitur : Hubungan Utang Piutang</span>
                <br />
                <br />
                Bank Memberikan Kredit Kepada Debitur, Debitur Membayar Pokok Hutang Beserta Bunga ke Bank Secara Mengangsur dalam Jangka Waktu yang DisepakatiBersama Antara Bank dan Debitur
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.2</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                <span style={{ fontWeight: "bold" }}>Developer - Debitur :Hubungan Jual Beli</span>
                <br />
                <br />
                Developer Sebagai Penjual, Debitur Sebagai Pembeli Sehingga Segala Sesuatu Mengenai Objek Rumah baik Fisik Rumah, Sarana dan Prasarana maupun Legalitasnya (Sertifikat dan IMB) Merupakan Tanggungjawab pihak Developer (Bukan Pihak Bank)
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>C.2</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                <span style={{ fontWeight: "bold" }}>Bank - Developer : Hubungan Kerjasama</span>
                <br />
                <br />
                Developer dan Bank Bekerjasama dalam Pembiayaan KPR bagi Pembeli Rumah yang Dibangun/ Dijual oleh Developer
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td rowSpan={2} colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                D. KETENTUAN KPR SUBSIDI
              </td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                Kesesuaian Kualifikasi Calon Debitur
              </td>
              <td style={{ width: "180px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Keterangan</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Ya</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", fontWeight: "bold" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.1</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Gaji Pokok Calon Debitur Sesuai dengan KPR Bersubsidi yang Berlaku</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.2</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Calon Debitur Belum Memiliki Rumah</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "10px", border: "1px solid #000", padding: "4px 6px", fontWeight: "bold", verticalAlign: "top" }}>D.3</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Calon Debitur Belum Pernah Memperoleh Fasilitas KPR Bersubsidi</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td colSpan={5} style={{ border: "1px solid #000", borderBottom: "none", padding: "8px 6px", textAlign: "justify" }}>
                Pada hari ini Tanggal ......... Saya/Kami yang bertandatangan dibawah ini telah memberikan keterangan data yang valid dalam wawancara yang dilakukan oleh Loan Service PT. Bank Tabungan Negara (Persero) Cabang ......... Untuk keperluan penilaian atas kelayakan kredit yang Saya/Kami ajukan.
                <br />
                <br />
                Saya/Kami telah memahami produk yang akan Saya/Kami ambil serta hubungan antara Bank BTN - Developer - Debitur dalam pengambilan KPR ini.
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "950px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td colSpan={5} style={{ textAlign: "center", border: "1px solid #000", fontWeight: "bold", padding: "4px 6px" }}>
                BANK BTN
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "50%" }}>
                Loan Service/ Petugas Wawancara
              </td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", width: "50%" }}>
                Pemohon
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", height: "80px" }}></td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>
                Nama : {item.sales_agent && item.sales_agent.name}
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Nama Pasangan : {item.sls_appl?.name_spouse ?? "-"}</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", fontWeight: "bold" }}>Nama Pemohon : {item.sls_appl?.name ?? "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
